$(document).ready(function () {
  const inputElement = document.getElementById("preapp_email_address");
  const outerContainerElement = document.getElementById(
    "preapp-email-marketing-consent-wrapper",
  );

  if (!inputElement) {
    return;
  }

  // Check the input value on page load
  if (inputElement.value.length > 1) {
    outerContainerElement.classList.add("--is-visible");
  }

  const handleChange = (event) => {
    const input = event.target.value;

    if (input.length > 1) {
      outerContainerElement.classList.add("--is-visible");
    }

    if (input.length === 0) {
      outerContainerElement.classList.remove("--is-visible");
    }
  };

  inputElement.addEventListener("input", handleChange);
});
